module.exports = __webpack_public_path__ + "img/logo-forge.e4b02493.png";